<div class="row">
    <div class="col-12">

        <form [formGroup]="leftRightForm">
            <aw-wizard #wizard class="arc-wizard" navBarLocation="left">

                <aw-wizard-step stepTitle="DOMANDA">
                    <div class="row">
                        <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="domanda">DOMANDA*</label>
                                    <input formControlName="domanda" type="text" class="form-control" id="domanda" aria-describedby="domanda" placeholder="">
                                    <small id="domandaHelp" class="form-text text-muted">Scrivi una domanda</small>
                                </div>
                                <div class="form-group">
                                    <label for="sottotitolo">SOTTOTITOLO</label>
                                    <textarea  formControlName="sottotitolo" class="form-control" id="sottotitolo" aria-describedby="sottotitoloHelp"></textarea>
                                    <small id="sottotitoloHelp" class="form-text text-muted">Scrivi un sottotitolo o un indicazione aggiuntiva</small>
                                </div>
                                <div class="form-group">
                                    <label for="hasImage">IMMAGINE DOMANDA</label>
                                    <div class="switch m-r-10">
                                        <input type="checkbox" id="hasImage" formControlName="hasImage" aria-describedby="hasImageHelp">
                                        <label for="hasImage" class="cr"></label>
                                    </div>
                                    <small id="hasImageHelp" class="form-text text-muted">La domanda prevede un'immagine?</small>
                                </div>
                                <div class="form-group" *ngIf="f.hasImage.value">
                                    <label>FEATURED IMAGE</label>
                                    <app-media-manager [filePath]="interaction.image" (onFileSelect)="setImageUrl($event, 'featuredImage')"></app-media-manager>
                                </div>
                                <div class="form-group">
                                    <label for="info">INFO</label>
                                    <app-tinymce formControlName="info" id="info" aria-describedby="infoHelp"></app-tinymce>
                                    <small id="infoHelp" class="form-text text-muted">Inserisci le info della tua Interazione</small>
                                </div>
                                <h6>Coordinate:</h6>
                                <div class="form-group">
                                    <label for="lat">LATITUDINE</label>
                                    <input formControlName="lat" type="text" class="form-control" id="lat" aria-describedby="latHelp" placeholder="41.89884227456026">
                                    <small id="latHelp" class="form-text text-muted">Inserisci la latitudine</small>
                                </div>
                                <div class="form-group">
                                    <label for="lat">LONGITUDINE</label>
                                    <input formControlName="lng" type="text" class="form-control" id="lng" aria-describedby="lngHelp" placeholder="12.52539241745996">
                                    <small id="lngHelp" class="form-text text-muted">Longitudine</small>
                                </div>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateDomanda()" (click)="setDomanda()">Avanti</button>
                        </div>
                    </div>
                </aw-wizard-step>

                <aw-wizard-step stepTitle="RISPOSTE">

                    <div class="row">
                        <div class="col-12">
                            <label for="domanda" class="mt-0">RISPOSTE*</label>
                            <div class="form-group">
                                <label for="domanda">Risposta a sinistra</label>
                                <input formControlName="rispostaSinistra" type="text" class="form-control" id="rispostaSinistra" aria-describedby="rispostaSinistra"[value]="interaction.interactionData?.risposte[0].label">
                                <small id="rispostaSinistraHelp" class="form-text text-muted">Scrivi la risposta che comparirà a sinistra.</small>
                            </div>
                            <div class="form-group">
                                <label for="domanda">Risposta a destra</label>
                                <input formControlName="rispostaDestra" type="text" class="form-control" id="rispostaDestra" aria-describedby="rispostaDestra" [value]="interaction.interactionData?.risposte[1].label">
                                <small id="rispostaDestraHelp" class="form-text text-muted">Scrivi la risposta che comparirà a destra.</small>
                            </div>
                        </div>

                        <div class="col-sm-12 mt-3 d-flex justify-content-end">
                            <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateRisposte()" (click)="setRisposte()">Avanti</button>
                        </div>
                    </div>
                </aw-wizard-step>

                <aw-wizard-step stepTitle="RISULTATO">
                    <div class="row">
                        <div class="col-12" *ngIf="interaction.interactionData">
                            <label for="hasImage">RISPOSTA ESATTA</label>
                            <small class="form-text text-muted">Seleziona la risposta esatta!</small>
                            <ul class="list-group mt-3" >
                                <li class="list-group-item"
                                    *ngFor="let risposta of interaction.interactionData.risposte; let i = index;"
                                    (click)="setRisultatoLeftRight(i)"
                                    [class.bg-primary]="risposta.value"
                                    [class.text-white]="risposta.value">
                                    {{risposta.label}}
                                </li>
                            </ul>
                            <div class="col-sm-12 mt-3 d-flex justify-content-end mt-3">
                                <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateRisultato()" (click)="onAddInteraction()">Avanti</button>
                            </div>
                        </div>
                    </div>
                </aw-wizard-step>
            
            </aw-wizard>
        </form>
    </div>
</div>

<!-- {{interaction | json}} -->